// composables/useLoading.ts
import { ref } from 'vue'

const isLoading = ref(false)

export function useLayoutLoader() {
  const start = () => (isLoading.value = true)
  const stop = () => (isLoading.value = false)

  return { isLoading, start, stop }
}
